export const GET_MEMBERSHIP_TYPES_REQUEST = 'GET_MEMBERSHIP_TYPES_REQUEST'
export const GET_MEMBERSHIP_TYPES_SUCCESS = 'GET_MEMBERSHIP_TYPES_SUCCESS'
export const GET_MEMBERSHIP_TYPES_FAIL = 'GET_MEMBERSHIP_TYPES_FAIL'
